module.exports = __webpack_public_path__ + "bootleggeres_coffee_stamp_design.jpg?fc38d25e8b42293a599f201ff55d4dff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/bootleggers/bootleggeres_coffee_stamp_design.jpg
// module id = 29
// module chunks = 0